import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";

import { useIsAppBarVisible } from "../../../useIsAppBarVisible";
import { STANDARD_LAYOUT_HEADER_ID } from "../constants";

export const PageHeaderContainer = ({
  children,
  className,
  ...rest
}: ComponentPropsWithoutRef<"header">) => {
  const isAppBarVisible = useIsAppBarVisible();

  return (
    <header
      id={STANDARD_LAYOUT_HEADER_ID}
      aria-label={t("page_header")}
      className={classNames(
        "z-20 sm:relative sm:top-0 lg:sticky",
        isAppBarVisible ? "top-16" : "top-0",
        className,
      )}
      {...rest}
    >
      {children}
    </header>
  );
};

export const StandardLayoutHeaderContainer = PageHeaderContainer;
